module.exports = __webpack_public_path__ + "img/tech-p3_pic.58d490ec.png";